<template>
  <div class="landing-page-not-found">
    <div class="landing-page-not-found__img">
      <img
        src="@/assets/images/landing/page-404.svg"
        alt="img"
      >
    </div>
    <div class="landing-page-not-found__title">
      {{ $t('page404.title') }}
    </div>
    <div class="landing-page-not-found__description">
      {{ $t('page404.description') }}
    </div>
    <button
      class="landing-page__button landing-page__button_primary"
      @click="goToHomePage"
    >
      {{ $t('page404.buttonText') }}
    </button>
  </div>
</template>

<script>

export default {
  name: 'Page404',
  beforeMount() {
    this.$router.replace({ path: '/404' });
  },
  methods: {
    goToHomePage() {
      this.$router.push('/');
    },
  },
};
</script>

<style scoped lang="scss">
@import "../sass/variables";
@import "../sass/mixins";

  .landing-page-not-found {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding-top: 30px;

    &__img {
      margin-bottom: 44px;
    }

    &__title {
      font: $font-size-landing-heading-large $font-landing-medium;
      margin-bottom: 10px;

      @include mobile {
        max-width: 300px;
        font-size: $font-size-landing-heading;
      }
    }

    &__description {
      margin-bottom: 25px;
      font: $font-size-landing-md $font-landing-global;

      @include mobile {
        max-width: 300px;
        text-align: center;
        font-size: $font-size-landing-sm;
      }
    }
  }
</style>
